/* eslint-disable @typescript-eslint/no-explicit-any */
import { Module, Commit } from "vuex";

// Define the interface for the Menu object
interface Menu {
  id: number;
}

// Define the type for the state
type MenusState = Menu[];

const initialState: MenusState = [];

export const menus: Module<MenusState, any> = {
  state: initialState,
  mutations: {
    storeMenus(state: MenusState, menus: Menu[]) {
      state.splice(0, state.length, ...menus);
    },
  },
  actions: {
    fetchMenus({ commit }: { commit: Commit }, items: Menu[]) {
      commit("storeMenus", items);
    },
  },
  getters: {
    getMenuById:
      (state: MenusState) =>
      (id: number): Menu | undefined => {
        return state.find((menu) => menu.id === id);
      },
  },
};
